<script>
    import { formattedDateAndTime, fromNow } from "../../utils/date";
    import { AppStore } from "$/stores/AppStore"
    import { ActiveTopic } from "$/stores/extension/ActiveTopicStore"
    import { TenantStore } from "$/stores/TenantStore";
    import BasicContent from "../content/BasicContent.svelte";
    import EntityParentContent from "../content/EntityParentContent.svelte";
    import UpdatedFieldsContent from "../content/UpdatedFieldsContent.svelte";
    import TopicRoleContent from "../content/TopicRoleContent.svelte";
    import { v4 as uuid } from "uuid";

    export let notification = {};

    $: destinationTenantId = TenantStore.contains(notification.tenantId)
        ? notification.tenantId
        : TenantStore.getPersonal().id;
    $: differentTenant = destinationTenantId !== $TenantStore?.active?.id;

    function navigateToNotification(event, notification) {
        const params = generateParams(notification);
        const currentTopicId = $ActiveTopic?.id;

        if (currentTopicId === params.topicId) {
            setFocusedParams(notification, params);
            return;
        }

        const urlTemplate = getUrlTemplate(notification, params);
        const newUrl = formatUrl(urlTemplate, params);
        
        if (differentTenant) {
            window.open(newUrl, "_blank");
        } else {
            window.history.pushState({}, "", newUrl);
            dispatchEvent(new Event("popstate"));
        }
    }

    function generateParams(notification) {
        return {
            tenantId: notification.tenantId,
            topicId: notification.content.topicId,
            snippetId: uuid(),
            commentId: notification.content.entity?.id || "",
        };
    }

    function getUrlTemplate(notification, params) {
        switch (notification.type) {
            case 3:
                return "/#/:tenantId/t/:topicId";
            default:
                switch (notification.content.entity.type) {
                    case "COMMENT":
                        return "/#/:tenantId/t/:topicId/s/:snippetId/c/:commentId";
                    case "SNIPPET":
                        params.snippetId = notification.content.entity.id;
                        return "/#/:tenantId/t/:topicId/s/:snippetId";
                    case "REACTION":
                        params.snippetId = notification.content.parent.id;
                        return "/#/:tenantId/t/:topicId/s/:snippetId";
                    case "MENTION":
                        params.commentId = notification.content.parent.id;
                        return "/#/:tenantId/t/:topicId/s/:snippetId/c/:commentId";
                    default:
                        return "/#/:tenantId/t/:topicId";
                }
        }
    }

    function setFocusedParams(notification, params) {
        const focusParams = {};
        switch (notification.content.entity.type) {
            case "COMMENT":
                focusParams.commentId = params.commentId;
                break;
            case "SNIPPET":
            case "REACTION":
                focusParams.snippetId = params.snippetId;
                break;
            case "MENTION":
                focusParams.commentId = params.commentId;
                break;
        }
        AppStore.setFocused(focusParams);
    }

    function formatUrl(template, params) {
        return Object.keys(params).reduce(
            (url, key) => url.replace(`:${key}`, params[key]),
            template
        );
    }

</script>

<div class="notification" 
    on:click={(event) => navigateToNotification(event, notification)}
>
    <div class="notification-date" title={formattedDateAndTime(notification.createdOn)}>
        {fromNow(notification.createdOn)}
    </div>

    {#if notification.type === 0}
        <BasicContent content={notification.content} />
    {:else if notification.type === 1}
        <EntityParentContent content={notification.content} />
    {:else if notification.type === 2}
        <UpdatedFieldsContent content={notification.content} />
    {:else if notification.type === 3}
        <TopicRoleContent content={notification.content} />
    {/if}
</div>

<style>
    .notification {
        @apply flex flex-col gap-1 border-b p-2 hover:cursor-pointer hover:bg-gray-100;
    }

    .notification-date {
        @apply text-xs text-gray-400;
    }
</style>
